import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import {dataFR} from "../assets/data/fr";
import {dataEN} from "../assets/data/en";
import {dataNL} from "../assets/data/nl"


i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      fr: {
        translation: dataFR,
      },
      en: {
        translation: dataEN,
      },
      nl: {
        translation: dataNL,
      },
    },

    detection: {
      order: [
        "cookie",
        "localStorage",
        "navigator",
        "htmlTag",
        "path",
        "subdomain",
      ],
      caches: ["cookie"],
    },

    fallbackLng: "en",
    debug: false,
    interpolation: {
      escapeValue: false,
    },
  });

i18n.changeLanguage("fr");

export default i18n;
